module.exports = __webpack_public_path__ + "media/features/landing-page/components/sections/navbar-section/images/menu-33d2d6bab6f4321418adf98c283f996f.webp";